import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DuplicateLeadService {


  url = environment.serverAPI9 + "/api/duplicateLead"; 
  
  constructor(private http: HttpClient) { }

  getAllDuplicateLeadScope(Page: any, size: any, sort: any, typeId: any = 1): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId || 1}`);
  }

  getAllDynmaicFormDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }
  getCustomerProductScopeById(formGroupId: number): Observable<Object> {
    return this.http.get(`${this.url}/${formGroupId}`);
  }

  addOrEditcustomerProductScope(dynamicformgroup: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, dynamicformgroup);
  }

  DuplicateLeadScopeSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
}
